import { colors } from "../../utils";
import { createUseStyles } from 'react-jss';



var styles = {
  tabsComponentWrapper: function tabsComponentWrapper(props) {return {
      borderRadius: '10px',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.14)',
      display: 'flex',
      width: props.width || 'max-content',
      backgroundColor: colors.neutral.white
    };},
  controllersSection: {
    paddingTop: '6.4rem',
    borderRight: "1px solid ".concat(colors.neutral[200]),
    flex: '0 0 17%',
    minWidth: 'max-content'
  },
  tabsButtonsWrapper: {
    borderTop: "1px solid ".concat(colors.neutral[200]),
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  tabButton: {
    margin: 0,
    padding: '1.2rem 1.2rem',
    boxSizing: 'border-box',
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500
    },
    letterSpacing: '0.2rem',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  tabButtonActive: {
    color: colors.neutral.white,
    backgroundColor: colors.blue[600]
  },
  subTabsButtonsWrapper: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column'
  },
  subTabButton: {
    boxSizing: 'border-box',
    padding: '0.8rem 1.6rem',
    cursor: 'pointer',
    font: {
      size: '1.4rem',
      lineHeight: '2.24rem'
    },
    display: 'inline-flex',
    marginLeft: '2.5rem'
  },
  subTabButtonActive: {
    color: colors.blue[600],
    fontWeight: 700,
    marginLeft: '0rem'
  },
  titleWrapper: { display: 'inline-block', marginRight: '0.4rem' }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map